<template>
  <div class="do-dont offWhite">
    <div class="container">
      <div class="title">
        <h2>{{ data.title }}</h2>
      </div>
      <div class="list-container">
        <div class="do-list">
          <ul>
            <li
              v-for="(item, i) in doItems"
              :key="`do-item_${i}`"
              :class="item.type"
            >
              {{ item.text }}
            </li>
          </ul>
        </div>
        <div class="dont-list">
          <ul>
            <li
              v-for="(item, i) in dontItems"
              :key="`dont-item_${i}`"
              :class="item.type"
            >
              {{ item.text }}
            </li>
          </ul>
        </div>
      </div>
      <hr />
      <div class="tagline-container">
        <div class="tagline-img">
          <img src="../assets/img/socialMedia.png" alt=" " />
        </div>
        <div class="tagline-text">
          <p>{{ data.taglineTitle }}</p>
          <ul>
            <li v-for="(item, i) in data.taglineItems" :key="`item_${i}`">
              {{ item.text }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Content from "../data/content";

export default {
  name: "DoDont",
  data() {
    const lang = process.env.VUE_APP_LOCALITY;
    return {
      data: Content[lang].doDont,
    };
  },
  computed: {
    doItems() {
      return this.data.items.filter((item) => item.type === "do");
    },
    dontItems() {
      return this.data.items.filter((item) => item.type === "dont");
    },
  },
};
</script>

<style>
.container {
  padding: 50px 0 70px;
  max-width: 1325px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  margin-bottom: 20px;
  max-width: 403px;
  text-align: center;
}

.list-container {
  display: flex;
  gap: 34px;
}

.do-list,
.dont-list {
  flex: 1;
  padding-left: 53px;
  max-width: 443px;
}

.do-list ul li,
.dont-list ul li {
  font-family: "JETSansDigital", sans-serif;
  color: #242e30;
  font-size: 16px;
  font-weight: 400;
  line-height: 130%;
  list-style: none;
  position: relative;
  margin-bottom: 15px;
}

.do-list ul li::before,
.dont-list ul li::before {
  height: 24px;
  width: 24px;
  position: absolute;
  left: -42px;
  top: 5px;
  content: "";
  background-position: center;
  background-size: contain;
}

.do-list ul li::before {
  background-image: url("../assets/icons/tick.svg");
}

.dont-list ul li::before {
  background-image: url("../assets/icons/cross.svg");
}

hr {
  height: 1.5px;
  width: 84%;
  border-color: #242e304d;
}

.tagline-container {
  display: flex;
  align-items: center;
  margin-top: 35px;
  gap: 30px;
}

.tagline-img,
.tagline-text {
  flex: 1;
}

.tagline-img {
  max-width: 432px;
  max-height: 248px;
}

.tagline-img img {
  width: 100%;
  height: 100%;
  border-radius: 27px;
  object-fit: cover;
}

.tagline-text {
  font-family: "JETSansDigital", sans-serif;
  max-width: 522px;
  max-height: 213px;
}

.tagline-text p {
  color: #242e30;
  font-size: 26px;
  font-weight: 700;
  line-height: 130%;
  margin: 0 0 10px;
}

.tagline-text ul {
  padding: 0;
  margin: 0;
}

.tagline-text li {
  color: #242e30;
  font-size: 16px;
  font-weight: 400;
  line-height: 130%;
  list-style: none;
  margin: 20px 0;
}

.tagline-container li::before {
  content: " ";
  display: inline-block;
  vertical-align: middle;
  position: absolute;
  top: -4px;
  font-size: 14px;
  left: -8px;
}

@media only screen and (max-width: 992px) {
  .container {
    justify-content: center;
    margin-bottom: 40px;
    padding: 18px 20px 26px;
  }

  .list-container {
    flex-direction: column;
    max-width: 100%;
    gap: 0;
  }

  .do-list,
  .dont-list {
    padding-left: 5px;
  }

  .tagline-container {
    flex-direction: column;
    align-items: center;
  }

  .tagline-img {
    width: 307.55px;
    height: 180px;
  }

  .tagline-text {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
  }

  .do-list ul li,
  .dont-list ul li {
    font-size: 14px;
    line-height: 18px;
  }

  .title h2 {
    font-size: 26px;
    line-height: 31px;
  }

  .tagline-text p {
    width: 100%;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
  }

  .tagline-text li {
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: center;
  }
}
</style>
